import styled from 'styled-components';
import CTA from '../../../atoms/CTA';
import { CTAIconPosition } from '../../../atoms/CTA/CTA.constants';

const LinkListWrapper = styled.div`
  margin-top: 40px;

  a {
    padding: 6px 0;
  }
`;

/**
 * @param {TeaserTileLinkListProps} props
 * @returns {React.ReactElement} The rendered component
 */
const TeaserTileLinkList = ({ linkList }) => {
  return (
    <LinkListWrapper>
      {linkList.map((link, idx) => (
        <div key={idx}>
          <CTA
            skin="TERTIARY"
            title={link.title}
            href={link.url}
            target={link.target}
            icon="ARROW_ANIMATION"
            iconPos={CTAIconPosition.Before}
            text={link.text}
          />
        </div>
      ))}
    </LinkListWrapper>
  );
};

export default TeaserTileLinkList;
